import { DeleteOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import errorHandler from 'shared/utils/errorHandler';
import styles from './index.module.scss';

/**
 *
 * @param modalTitle (Title of the modal)
 * @param instructionMessage (Instruction for bulk upload)
 * @param templatePath (Path for downloading sample file)
 * @param previewPath (Path for preview uploaded File)
 * @param isModalVisible (Flag for modal should visible or not)
 * @param setIsModalVisible (Function to set visible flag)
 *
 * @returns
 */

export interface IUploadBulkModal {
	modalTitle: string | undefined;
	instructionMessage: any;
	templatePath: any;
	previewPath: any;
	isModalVisible: boolean | undefined;
	setIsModalVisible: any;
	companyId?: string | null;
	shopId?: string;
	shouldShowDownloadSample?: boolean;
	[x: string]: any;
}
export const UploadBulkModal = ({
	modalTitle,
	instructionMessage,
	templatePath,
	previewPath,
	isModalVisible,
	setIsModalVisible,
	companyId,
	shopId = '',
	shouldShowDownloadSample = true
}: IUploadBulkModal) => {
	const [excelFile, setExcelFile] = useState<any>(null);
	const history = useHistory();

	const handleCloseModal = () => setIsModalVisible(false);

	const handleDownloadSample = () => {
		window.open(templatePath, 'blank', 'noopener');
	};

	const deleteFile = () => {
		setExcelFile(null);
	};

	/**
	 * Called When user upload ean excel file
	 */
	const handleFileChange = (e: any) => {
		try {
			const file = e.target?.files[0];

			if (!file) {
				throw new Error('No file selected');
			}

			setExcelFile(file);
		} catch (error) {
			errorHandler(error);
		}
	};

	/**
	 * To Preview excel file
	 */
	const previewFile = async () => {
		try {
			if (!excelFile) {
				throw new Error('Please select a file to continue');
			}
			history.push({
				pathname: previewPath,
				state: { file: excelFile, ...(companyId && { companyId }), ...(shopId && { shopId }) }
			});
		} catch (error) {
			errorHandler(error);
		}
	};

	return (
		<Modal
			title={modalTitle}
			visible={isModalVisible}
			onCancel={handleCloseModal}
			okText="Preview File"
			onOk={previewFile}
			centered
			className={styles.uploadBulkModal}
		>
			<h5 className={styles.heading}>Instructions to upload</h5>

			{/* Instruction Part */}
			{instructionMessage}

			<div className={styles.buttonsContainer}>
				{shouldShowDownloadSample && <Button onClick={handleDownloadSample}>Download Sample</Button>}

				{excelFile?.name ? (
					<div className={styles.fileDetails}>
						<p className={styles.fileName}>{excelFile.name}</p>
						<Button danger icon={<DeleteOutlined />} onClick={deleteFile} />
					</div>
				) : (
					<>
						<label htmlFor="bulk-upload" className={styles.uploadLabel}>
							Upload Excel
						</label>
						<input
							id="bulk-upload"
							className={styles.uploadButton}
							style={{ width: '60px' }}
							accept=".xlsx"
							type="file"
							onChange={handleFileChange}
							value={excelFile || ''}
						/>
					</>
				)}
			</div>
		</Modal>
	);
};
